export default __webpack_public_path__ + "static/media/HT-minor.934e31af.svg";